<template>
  <div class="new-grouping">
    <b-modal ref="mapGroupRef" :title="'Add Grouping'" @hide="cancelNewGrouping" @shown="focusOnInput" class="modal-info" centered>
      <b-container fluid>
        <b-row class="mb-3">
          <b-col cols="3">Name<i class="required">*</i></b-col>
          <b-col>
            <b-form-input type="text" v-model="group.name" placeholder="Group Name" ref="groupName" required></b-form-input>
            <div v-if="group.name && !group.isNameUnique" style="color:red">Name must be unique.</div>
          </b-col>
        </b-row>
        <b-row class="mb-3">
          <b-col cols="3">Type<i class="required">*</i></b-col>
          <b-col>
            <b-form-select :plain="true" :options="groupTypes" v-model="group.type" placeholder="Group Type" @input="handleRequired()">
            </b-form-select>
          </b-col>
        </b-row>
        <b-row class="mb-3">
            <b-col cols="3" class="modal-label">{{ $t('TEMPLATE.ORDER_OF_OCCUR') }}</b-col>
            <b-col>
              <b-form-select :plain="true" :options="orderOptions" v-model="group.order" placeholder="Group Order">
              </b-form-select>
            </b-col>
          </b-row>
        <b-row class="mb-3" v-if="canShowRequired">
          <b-col cols="3">{{ $t('TEMPLATE.REQ') }}</b-col>
          <b-col>
            <b-form-radio-group>
              <div class="custom-control custom-radio custom-control-inline">
                <input type="radio" id="requiredGrpNewYes" class="custom-control-input" :value="true" v-model="group.required">
                <label class="custom-control-label" for="requiredGrpNewYes">{{ $t('COMMON.YES') }}</label>
              </div>
              <div class="custom-control custom-radio custom-control-inline">
                <input type="radio" id="requiredGrpNewNo" class="custom-control-input" :value="false" v-model="group.required">
                <label class="custom-control-label" for="requiredGrpNewNo">{{ $t('COMMON.NO') }}</label>
              </div>
            </b-form-radio-group>
          </b-col>
        </b-row>
        <b-row class="mb-3" v-if="selectedChildren.length > 1">
          <b-col cols="12">
            <h6 class="pull-left select-mappings">Select the mappings to include in the group:</h6>
          </b-col>
          <b-col cols="6" v-for="child in groupChildren" :key="child.attrs.path">
            <input class="pull-left mt-1 mr-2" type="checkbox" :id="child.attrs.uniq_id" :value="child.attrs.uniq_id" v-model="selectedChildren">
            <label class="pull-left" :for="child.attrs.uniq_id">
              {{child.attrs.key}} {{ child.attrs.map_type === 'shape' ? null : `( ${child.attrs.map_type} )`}}
            </label>
          </b-col>
        </b-row>
      </b-container>
      <div slot="modal-footer" class="w-100 d-flex justify-content-end">
        <b-btn size="sm" class="float-right" variant="primary mr-1" @click="createNewGrouping" :disabled="!validateGroupInfo">Add</b-btn>
        <b-btn size="sm" class="float-right" variant="light" @click="cancelGrouping">Cancel</b-btn>
      </div>
    </b-modal>
    <b-modal :title="'New-Grouping'" hide-header-close centered ok-only ok-variant="secondary" @ok="clearGrouping" ref="agnetNewGroupingModal">
      <p>You are not permitted to access this. Kindly contact administrator</p>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: ['mappingsKeys', 'showNewGrouping', 'groupChildren', 'orderOptions', 'mappingsOrderValues'],
  data () {
    return {
      group: {
        name: null,
        type: null,
        required: false,
        isNameUnique: false,
        order: null
      },
      groupTypes: [
        { value: null, text: 'Please select type' },
        { value: 'logical', text: this.$t('DATA_TYPE.LOGICAL') },
        { value: 'name', text: this.$t('DATA_TYPE.NAME') },
        { value: 'combine_data', text: this.$t('DATA_TYPE.COMBINE_DATA') },
        { value: 'checkbox_text', text: this.$t('DATA_TYPE.CHECKBOX_TEXT') },
        { value: 'single_select', text: this.$t('DATA_TYPE.EITHER') },
        { value: 'multi_select', text: this.$t('DATA_TYPE.MULTI_CHOICE') },
        { value: 'table_header', text: this.$t('DATA_TYPE.TABLE_HEADER') },
        { value: 'table_entry', text: this.$t('DATA_TYPE.TABLE_ENTRY') },
        { value: 'table_row', text: this.$t('DATA_TYPE.TABLE_ROW') },
        { value: 'table_column', text: this.$t('DATA_TYPE.TABLE_COLUMN') },
        { value: 'section', text: this.$t('DATA_TYPE.SECTION') }
      ],
      canShowRequired: false,
      selectedChildren: []
    }
  },
  computed: {
    validateGroupInfo: function () {
      return !!this.group.name && !!this.group.type && this.group.isNameUnique
    },
    ...mapGetters(['isAdminRole'])
  },
  watch: {
    showNewGrouping: function () {
      if (this.showNewGrouping) {
        if (this.isAdminRole) {
          this.group.name = null
          this.group.type = null
          this.group.required = false
          this.group.order = this.orderOptions.length
          this.selectedChildren = this.groupChildren.map(function (child, index) { return child.attrs.uniq_id })
          this.$refs.mapGroupRef.show()
        } else {
          this.$refs.agnetNewGroupingModal.show()
        }
      } else {
        this.$refs.mapGroupRef.hide()
      }
    },
    'group.name': function (key) {
      this.group.isNameUnique = key ? (this.mappingsKeys.indexOf(key.toString().toLowerCase().replace(/\s/g, '')) === -1) : false
    }
  },
  methods: {
    focusOnInput () {
      this.$refs.groupName.focus()
    },
    clearGrouping () {
      this.$refs.agnetNewGroupingModal.hide()
      this.$emit('cancelled')
    },
    createNewGrouping () {
      let selectedChildren = this.selectedChildren
      this.$emit('created', this.group, selectedChildren)
      this.selectedChildren = []
    },
    cancelGrouping () {
      this.$refs.mapGroupRef.hide()
      this.$emit('cancelled')
    },
    cancelNewGrouping () {
      this.$emit('cancelled')
    },
    handleRequired () {
      if (this.group.type === 'single_select' || this.group.type === 'multi_select') {
        this.canShowRequired = true
      } else {
        this.group.required = false
        this.canShowRequired = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .select-mappings {
    font-weight: 600;
    color: #1099c9;
  }

  .required {
    color: red;
  }
</style>



// WEBPACK FOOTER //
// src/views/templates/newGrouping.vue